import { Image } from 'antd';
import React from 'react';

const getPreviewImageSource = (image = {}) => {
  const url = image?.url || '';
  if (url?.includes('adloggs.com')) {
    return image?.key || url;
  }

  return url || image?.key || '';
};

const CommonPreviewTable = ({ visible, setVisible, images, setImages }) => (
  <div className="d-none">
    <Image.PreviewGroup
      preview={{
        visible,
        onVisibleChange: (vis) => {
          setVisible(vis);
          setImages([]);
        },
      }}
    >
      {images?.map((image) => (
        <Image
          width={20}
          src={getPreviewImageSource(image)}
          key={image?.key || image?.url}
        />
      ))}
    </Image.PreviewGroup>
  </div>
);

export default CommonPreviewTable;
